import { Link } from "react-router-dom";

const css = `
  .sf-root{background:#0e1f10;color:#c8d8b8;font-family:'Source Sans 3',sans-serif;padding:36px 24px 28px;margin-top:48px;}
  .sf-inner{max-width:960px;margin:0 auto;display:flex;flex-wrap:wrap;gap:28px 40px;align-items:flex-start;justify-content:space-between;}
  .sf-brand{font-family:'Playfair Display',serif;font-size:18px;font-weight:500;color:#fff;margin-bottom:6px;}
  .sf-tag{font-size:12px;color:#8aa08a;max-width:280px;line-height:1.6;}
  .sf-links{display:flex;flex-wrap:wrap;gap:18px 24px;font-size:13px;}
  .sf-links a{color:#c8d8b8 !important;text-decoration:none;transition:color .15s;}
  .sf-links a:hover{color:#fff !important;}
  .sf-bottom{max-width:960px;margin:24px auto 0;padding-top:20px;border-top:1px solid #1a3a1e;font-size:11px;color:#6a7a6a;text-align:center;}
  @media (max-width:640px){.sf-inner{flex-direction:column;gap:20px;}.sf-links{gap:14px 20px;}}
`;

export default function SiteFooter() {
  return (
    <>
      <style>{css}</style>
      <footer className="sf-root">
        <div className="sf-inner">
          <div>
            <div className="sf-brand">AmishCountryFinder</div>
            <div className="sf-tag">A free directory of Amish-owned businesses and an editorial blog on Amish culture, history, and travel.</div>
          </div>
          <nav className="sf-links" aria-label="Footer">
            <Link to="/">Home</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/about">About</Link>
            <Link to="/submit-business">Submit a Business</Link>
            <Link to="/report-listing">Report a Listing</Link>
            <Link to="/winners">Winners</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms">Terms</Link>
          </nav>
        </div>
        <div className="sf-bottom">
          © {new Date().getFullYear()} AmishCountryFinder.org · All rights reserved
        </div>
      </footer>
    </>
  );
}
